<template>
  <div>
    <Loader :isLoading="isLoading" />
    <landing-create :content="content"></landing-create>
    <list-component
      :service="service"
      :tableMetaData="tableMetaData"
    ></list-component>
  </div>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import ListComponent from '../../../components/ListComponent.vue';
import services from '../../../services';
import Loader from '../../../components/utilities/Loader.vue';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { caseSpecimenService } = biobankRegistry;

export default {
  name: 'SpecimenList',
  components: {
    ListComponent,
    LandingCreate,
    Loader,
  },
  data() {
    const component = this;
    return {
      service: caseSpecimenService,
      isLoading: false,
      specimenQuestions: null,
      tableMetaData: {
        tableFilters: {
          selections: [],
          dates: [
            {
              text: 'Date created',
              column: 'dateCreated',
            },
            {
              text: 'Date updated',
              column: 'dateUpdated',
            },
          ],
        },
        tableHeaders: [
          {
            text: 'Specimen Code',
            value: 'code',
          },
          {
            text: 'Case Number',
            value: 'caseNumber._id.caseNumber',
          },
          {
            text: 'Specimen Type',
            value: 'specimenType.name',
          },
          {
            text: 'Preparation',
            value: 'specimenState.name',
          },
          {
            text: 'Created by',
            value: '_metadata.created.user.fullName',
          },
          {
            text: 'Date created',
            value: '_metadata.created.date',
          },
          {
            text: 'Actions',
            value: 'actions',
          },
        ],
        URLName: 'specimen',
        actionDisplay: {
          delete: {
            visible: true,
            icon: () => 'mdi-delete-empty',
          },
        },
        onClickArchive(item) {
          component.onArchive(item);
        },
      },
      content: {
        pageTitle: 'Specimen',
        commands: [
          {
            link: 'specimen.create',
            icon: 'mdi-plus-box',
            buttonName: 'Create',
          },
        ],
        // Enable import function
        importData: {
          // enable this import by setting the active to true
          active: true,
          isNavOpen: false,
          icon: 'mdi-file-import',
          buttonName: 'IMPORT DATA',
          onImportData: async ({
            formData,
            projectCodeId,
            specimenSourceId,
            projectFormId,
          }) => {
            this.isLoading = true;
            try {
              const { data } = await caseSpecimenService.upload({
                formData,
                projectCodeId,
                specimenSourceId,
                projectFormId,
              });
              const url = window.URL.createObjectURL(new Blob([data.txtFile]));
              const link = document.createElement('a');
              setTimeout(() => {
                // download the upload here
                link.href = url;
                link.setAttribute('download', 'import_reports.txt');
                document.body.appendChild(link);
                link.click();

                this.isLoading = false;
                this.$snackbar.show({
                  text: `
                    <div style="font-size: 18px; margin-bottom:10px;">
                      ${data.render} 
                    </div>
                    <div style="display: flex; justify-content: center; font-size: 18px;" align-items: center;>
                      <v-btn block style="color:white; background:transparent; border:1px solid white; padding:5px; cursor:pointer;" onclick="window.location.reload()">Refresh Page to update data</v-btn>
                    </div>`,
                  closeColor: 'white',
                  color: 'green',
                  showClose: false,
                  timeout: -1,
                });
              }, 2000);
            } catch (e) {
              const error = e.response.data;
              this.$snackbar.showBad({
                text: ErrorMessageUtil.transform(error),
              });
            }
          },
        },
      },
    };
  },
  methods: {
    async onArchive(item) {
      this.isLoading = true;
      try {
        await caseSpecimenService.archive({ specimen: item });
        this.$snackbar.show({
          text: 'Successfully deleted specimen!',
          closeColor: 'white',
          color: 'green',
        });
      } catch (e) {
        console.log('catch', e);
        const { message } = e.response.data;
        this.$snackbar.show({ color: 'red', text: message, closeColor: 'white' });
      }
      this.isLoading = false;
    },
  },
};
</script>
